import { Component, Input, HostListener, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { RouteInfo } from '../rol-sidebar/rol-sidebar.metadata';
import { Router, NavigationEnd } from '@angular/router';
import { RolSidebarService } from '../rol-sidebar.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-rol-sidebar-item',
  templateUrl: './rol-sidebar-item.component.html',
  styleUrls: ['./rol-sidebar-item.component.css']
})
export class RolSidebarItemComponent implements OnInit, OnDestroy {
  @Input() item!: RouteInfo;
  expanded = false;
  private subscription?: Subscription;
  private itemId: string;

  constructor(
    private router: Router, 
    private elementRef: ElementRef,
    private sidebarService: RolSidebarService
  ) {
    // Generate unique ID for this item
    this.itemId = this.item?.title?.toLowerCase().replace(/\s+/g, '-') || 'item-' + Math.random().toString(36).substr(2, 9);
  }

  ngOnInit() {
    // Subscribe to active dropdown changes
    this.subscription = this.sidebarService.activeDropdown$.subscribe(activeId => {
      this.expanded = activeId === this.itemId;
    });

    // Close dropdown when route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.sidebarService.setActiveDropdown(null);
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  toggleExpand(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.expanded) {
      // If already expanded, close it
      this.sidebarService.setActiveDropdown(null);
    } else {
      // If not expanded, close others and open this one
      this.sidebarService.setActiveDropdown(this.itemId);
    }
  }

  navigate(path: string) {
    if (path) {
      this.router.navigate([path]);
      // Always close dropdown after navigation (for both main items and submenu items)
      this.sidebarService.setActiveDropdown(null);
    }
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    
    // Check if click is outside this component
    if (!this.elementRef.nativeElement.contains(target)) {
      this.sidebarService.setActiveDropdown(null);
    }
  }
}
